import React, { useEffect, useState } from "react";
import { Checkbox } from 'antd';
import "./CheckBoxRenderer.css";


const CheckBoxRenderer = (props) => {
  const { data, onButtonClick, user_agencies, api, updateData, rowNode } = props;

  const handleButtonClick = (e) => {
    const { checked } = e.target;
    // checked ? data._justChecked = true : data._justChecked = false;
    data._justChecked = checked; 
    data.isChecked = checked;
    api.applyTransaction({ update: [data] });
    if (onButtonClick) onButtonClick(data, checked);
  };

  return <div
  >
    <Checkbox onChange={handleButtonClick} 
    checked={!!data.isChecked} 
    className="agency-checkbox" />
  </div>;
};

export default CheckBoxRenderer;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/Modals/CheckBoxRenderer.js